import { useResourceAppLocation } from "@react-admin/ra-navigation";

export const useCurrentView = () => {
  const { path } = useResourceAppLocation() || {};
  const [_, view] = path?.split(".") || [];
  return view || "list";
};
